import { render, staticRenderFns } from "./HistoryDataView.vue?vue&type=template&id=08b6a8ed&scoped=true"
import script from "./HistoryDataView.vue?vue&type=script&lang=js"
export * from "./HistoryDataView.vue?vue&type=script&lang=js"
import style0 from "./HistoryDataView.vue?vue&type=style&index=0&id=08b6a8ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6a8ed",
  null
  
)

export default component.exports